import clsx from 'clsx';
import InButtonLoader from '../../../../common/components/InButtonLoader';
import {WithChildren} from '../../../../common/helpers';

interface Props {
	canNotSubmit: boolean;
	loading: boolean;
}

const Btn = ({canNotSubmit, loading, children}: Props & WithChildren) => {
	return (
		<button
			type='submit'
			className={clsx('p-3 rounded-4xl text-white text-base md:text-xs lg:text-base font-medium w-full', {
				'bg-primary/50': canNotSubmit,
				'bg-primary': !canNotSubmit,
			})}
			disabled={canNotSubmit}
		>
			<InButtonLoader isLoading={loading} showIcon showText>
				{children}
			</InButtonLoader>
		</button>
	);
};

type ExternalProps = Props & WithChildren & {outerDiv?: boolean};

export default function SubmitButton({outerDiv = true, ...rest}: ExternalProps) {
	if (!outerDiv) return <Btn {...rest} />;

	return (
		<div className='mb-6 sm:mb-3 lg:mb-6'>
			<Btn {...rest} />
		</div>
	);
}
